import {
  CorrectAnswerType,
  ISequence,
  MusicLevelsEnum,
  SequenceDialougeDirection,
} from 'src/app/common/interfaces';
import { IOpenAiFiles } from '../api/openApi-file.service';

export interface IJourney {
  _id: string;
  userId: string;
  companyId: string;
  divisionId: string;
  name: string;
  __deletedAt__?: Date | undefined;
  gameFormat: GenieGames;
  topic?: string;
  textContent?: string;
  contentFiles: IOpenAiFiles[];
  questions?: IQuestion[] | string[];
  url?: string;
  status?: Status;
  packageUrl?: string;
  createdAt?: string;
  updatedAt?: string;
  playersCount?: number;
  translatedLanguages: string[];
  jumbles?: IJumble[];
  completedPlayersCount: number;
  questionSelectedCount: number;
  learningGameId: string;
  oneTimePlay: boolean;
  maxAttempts?: number;
  showOptionIndicator: boolean;
  questionType: 'multiple attempt' | 'single attempt';
  fileUrl?: string;
  tutorialFiles: {
    id: string;
    name: string;
    url: string;
    fileType: 'Pdf' | 'Videos';
    created_at: string;
    language: string;
  }[];
  startDate?: Date;
  endDate?: Date;
  __v?: number;
}

export enum GenieGames {
  KBC = 'Kbc',
  SLIDERGAME = 'SliderGame',
  MAZEGAME = 'MazeGame',
  MARIOGAME = 'MarioGame',
  ANGRYBIRDGAME = 'AngryBirdGame',
  BUBBLESHOOTERGAME = 'BubbleShooterGame',
  FRUITNINJAGAME = 'FruitNinjaGame',
  PATHFINDERGAME = 'PathFinderGame',
  SNAKELADDERGAME = 'SnakeLadderGame',
  PARADROPGAME = 'ParadropGame',
  SPOTONGAME = 'SpotOnGame',
  CROSSWORDSGAME = 'CrosswordsGame',
  POOLGAME = 'PoolGame',
  FIREPILOTGAME = 'FirePilotGame',
  STICKCRICKETGAME = 'StickCricketGame',
  RACINGGAME = 'RacingGame',
  SWIPEGAME2 = 'SwipeGame2',
  JUMBLESGAME = 'JumblesGame',
  SWIPEGAME = 'SwipeGame',
  QUESTIONS = 'QuestionsGame',
  STRAIGHTSHOOTERGAME = 'StraightShooterGame',
  WORDPUZZLESGAME= 'WordsPuzzleGame'
}

export enum Status {
  INCOMPLETE = 'Incomplete',
  ACTIVE = 'Active',
  INACTIVE = 'Inactive',
}

export interface IQuestion {
  _id: string;
  name?: string;
  backgroundId?: string;
  text: string;
  musicVolume: MusicLevelsEnum;
  musicId?: string;
  companyId: string;
  timer: number;
  supportingImage?: string;
  correctAnswers: CorrectAnswerType;
  options: IQuestionOptions[];
  leftCharacter?: string;
  rightCharacter?: string;
  dialougeSource?: SequenceDialougeDirection;
  createdAt?: Date;
  updatedAt?: Date;
  type?: IJourney['questionType'];

  showOptionIndicator?: IJourney['showOptionIndicator'];
}

export interface IQuestionOptions {
  _id?: string;
  sequenceId: string | ISequence;
  text: string;
  isCorrect: boolean;
  feedback?: string;
}

interface QuizOption {
  [key: string]: string;
}

interface QuizFeedback {
  [key: string]: string;
}

export interface QuizQuestion {
  index: number;
  questionText: string;
  options: QuizOption;
  feedback: QuizFeedback;
  correct_option: string;
}

export interface IJumble {
  _id: string;
  name: string;
  isDeleted: boolean;
  hint: string;
  musicVolume: string;
  timer: number;
  correctWord: string;
  alphabets: string[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface IJourneyLanguage {
  _id: string;
  gameFormat:
    | 'QuestionsGame'
    | 'MarioGame'
    | 'BubbleShooterGame'
    | 'SliderGame'
    | 'AngryBirdGame'
    | 'FirePilotGame'
    | 'StickCricketGame'
    | 'FruitNinjaGame'
    | 'SwipeGame'
    | 'SwipeGame2'
    | 'JumblesGame'
    | 'MazeGame'
    | 'PoolGame'
    | 'RacingGame'
    | 'PathFinderGame'
    | 'SpotOnGame'
    | 'SnakeLadderGame'
    | 'ParadropGame'
    | 'StraightShooterGame'
    | 'WordsPuzzleGame'
    | 'CrosswordsGame'
    | '';
  translatedLanguages: Array<'hi' | 'mr' | 'gu' | 'ml'>;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface CortevaParticipant {
  _id?: string;
  name: string;
  email: string;
  designation: string;
  mobileNumber: string | number;
  cuZone: string;
  zone?: string;
  state: string;
  territory: string;
  reportingManagerName: string;
}
